/**
 * Como a espera reconhece o evento desta automação: pela mesma conversa, pela
 * mesma oportunidade. Escolhe-se pelo nome; o caminho (`conversation_id`) fica
 * para o serviço. A expressão escrita continua possível.
 */

import { useState, type ReactNode } from 'react';
import type { BlocosDoEditor } from '@cliqcrm/contracts';
import { Botao, Campo, CampoSelecao } from '@/shared/ui';
import { comPreposicao } from '../lib/referencias';
import { ComCamposDoEvento } from './inserir-campo';

type Referencia = BlocosDoEditor['eventos'][number]['referencias'][number];

export function ReconhecerOEvento({
  referencias,
  campos,
  valor,
  aoMudar,
}: {
  referencias: readonly Referencia[];
  campos: readonly string[];
  valor: string;
  aoMudar: (valor: string) => void;
}): ReactNode {
  const [pediuExpressao, definirPediuExpressao] = useState(false);
  const escolhida = referencias.find((r) => r.caminho === valor.trim());
  const porEscolha =
    !pediuExpressao && referencias.length > 0 && (valor.trim() === '' || escolhida !== undefined);

  if (porEscolha) {
    return (
      <div className="editor-do-mapa__condicao">
        <CampoSelecao
          rotulo="Como reconhecer o evento desta automação"
          ajuda="O evento esperado precisa ser da mesma conversa (ou oportunidade) que começou."
          value={escolhida?.caminho ?? ''}
          onChange={(e) => aoMudar(e.target.value)}
        >
          <option value="">Escolha</option>
          {referencias.map((r) => (
            <option key={r.caminho} value={r.caminho}>
              {comPreposicao('por', r.titulo)}
            </option>
          ))}
        </CampoSelecao>
        <Botao variante="fantasma" miudo onClick={() => definirPediuExpressao(true)}>
          Usar uma expressão
        </Botao>
      </div>
    );
  }

  return (
    <div className="editor-do-mapa__condicao">
      <ComCamposDoEvento campos={campos} valor={valor} aoMudar={aoMudar}>
        {(ref) => (
          <Campo
            ref={ref}
            rotulo="Como reconhecer o evento desta automação"
            ajuda="A chave que liga o evento esperado a esta automação, como conversation_id."
            spellCheck={false}
            value={valor}
            onChange={(e) => aoMudar(e.target.value)}
          />
        )}
      </ComCamposDoEvento>
      {referencias.length > 0 && (
        <Botao
          variante="fantasma"
          miudo
          onClick={() => {
            definirPediuExpressao(false);
            if (!escolhida) aoMudar('');
          }}
        >
          Voltar às escolhas
        </Botao>
      )}
    </div>
  );
}
